import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'
import Label from '../../../components/forms/label'
import CheckBox from '../../../components/forms/CheckBox'

export default class CommentListItem extends PureComponent {
  handleCheckBoxChange = ({ checked }) => {
    const { comment, onSelect } = this.props
    const idString = comment.id
    onSelect(idString, checked)
  }

  render() {
    const { comment, isChecked } = this.props
    const idString = comment.id.toString()
    const commentText = comment.comment
    const className = comment.visible ? 'visible' : 'hidden'
    return (
      <li className={className}>
        <Label>
          <CheckBox onChange={this.handleCheckBoxChange} checked={isChecked} value={idString} />
          &nbsp;
          <span className="comment-text" data-testid="comment-text">
            {commentText}
          </span>
        </Label>
      </li>
    )
  }
}
CommentListItem.propTypes = {
  comment: PropTypes.shape({
    comment: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
  }).isRequired,
  isChecked: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}
CommentListItem.defaultProps = {
  isChecked: false,
  comment: null,
  onSelect: noop,
}
